module.exports = __webpack_public_path__ + "static/media/success-check.7701bf75.svg";